const OKB = ({ ...props }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <circle cx="10.1104" cy="10" r="10" fill="white" />
      <path
        d="M9.21312 9.08227C9.81631 9.22997 10.4462 9.22997 11.0494 9.08227C11.2178 8.39675 11.5708 7.77044 12.0699 7.27129C12.5691 6.77214 13.1954 6.41921 13.8809 6.25078C14.0198 5.68257 14.0278 5.09021 13.9042 4.51846C13.7807 3.94671 13.5288 3.41051 13.1676 2.95038C12.8064 2.49026 12.3454 2.11822 11.8194 1.8624C11.2933 1.60657 10.716 1.47363 10.1311 1.47363C9.5461 1.47363 8.9688 1.60657 8.44276 1.8624C7.91671 2.11822 7.45569 2.49026 7.09451 2.95038C6.73333 3.41051 6.48144 3.94671 6.35787 4.51846C6.2343 5.09021 6.24228 5.68257 6.38121 6.25078C7.06681 6.41914 7.6932 6.77205 8.19243 7.2712C8.69166 7.77035 9.04466 8.3967 9.21312 9.08227V9.08227Z"
        fill="#7ABDF7"
      />
      <path
        d="M11.0495 10.9177C10.4463 10.77 9.81637 10.77 9.21318 10.9177C9.04462 11.6032 8.69165 12.2294 8.19252 12.7285C7.69339 13.2277 7.06715 13.5807 6.3817 13.7492C6.24277 14.3174 6.23479 14.9098 6.35836 15.4815C6.48193 16.0533 6.73382 16.5895 7.095 17.0496C7.45618 17.5097 7.9172 17.8818 8.44324 18.1376C8.96929 18.3934 9.54659 18.5264 10.1315 18.5264C10.7165 18.5264 11.2938 18.3934 11.8198 18.1376C12.3459 17.8818 12.8069 17.5097 13.1681 17.0496C13.5293 16.5895 13.7812 16.0533 13.9047 15.4815C14.0283 14.9098 14.0203 14.3174 13.8814 13.7492C13.1958 13.5808 12.5694 13.2279 12.0702 12.7288C11.5709 12.2296 11.2179 11.6033 11.0495 10.9177V10.9177Z"
        fill="#0D74F5"
      />
      <path
        d="M14.7988 6.13965C14.4895 6.13961 14.1814 6.17676 13.881 6.25032C13.7127 6.93575 13.3598 7.56197 12.8607 8.06105C12.3616 8.56013 11.7354 8.913 11.05 9.08138C10.9023 9.68457 10.9023 10.3145 11.05 10.9177C11.7354 11.0862 12.3616 11.4391 12.8607 11.9383C13.3598 12.4374 13.7127 13.0637 13.881 13.7492C14.4113 13.8787 14.9629 13.8943 15.4996 13.7949C16.0363 13.6956 16.5458 13.4836 16.9946 13.1729C17.4433 12.8622 17.821 12.4598 18.1029 11.9924C18.3847 11.525 18.5642 11.0031 18.6296 10.4613C18.6949 9.91938 18.6446 9.3698 18.482 8.84879C18.3193 8.32778 18.048 7.84719 17.686 7.43871C17.324 7.03024 16.8795 6.70317 16.3818 6.4791C15.8841 6.25503 15.3446 6.1399 14.7988 6.13965Z"
        fill="#4494F7"
      />
      <path
        d="M9.21313 10.9177C9.36083 10.3145 9.36083 9.6846 9.21313 9.08141C8.52766 8.91302 7.90139 8.56015 7.40225 8.06108C6.9031 7.56201 6.55014 6.93579 6.38164 6.25035C5.81343 6.11142 5.22107 6.10344 4.64932 6.22701C4.07757 6.35058 3.54137 6.60247 3.08124 6.96365C2.62111 7.32483 2.24908 7.78585 1.99326 8.3119C1.73743 8.83794 1.60449 9.41524 1.60449 10.0002C1.60449 10.5851 1.73743 11.1625 1.99326 11.6885C2.24908 12.2145 2.62111 12.6756 3.08124 13.0367C3.54137 13.3979 4.07757 13.6498 4.64932 13.7734C5.22107 13.897 5.81343 13.889 6.38164 13.75C6.54998 13.0644 6.90286 12.4379 7.40202 11.9386C7.90117 11.4393 8.52752 11.0862 9.21313 10.9177V10.9177Z"
        fill="#005CF4"
      />
      <path
        d="M11.0488 10.918C11.2173 11.6037 11.5703 12.2302 12.0696 12.7295C12.5689 13.2288 13.1954 13.5819 13.8812 13.7504C13.7125 13.0647 13.3595 12.4383 12.8602 11.939C12.3609 11.4397 11.7345 11.0866 11.0488 10.918V10.918Z"
        fill="#0246F2"
      />
      <path
        d="M11.0488 9.08575C11.2173 8.40003 11.5703 7.77354 12.0696 7.27424C12.5689 6.77495 13.1954 6.42191 13.8812 6.25343C13.7125 6.93909 13.3595 7.56551 12.8602 8.06479C12.3609 8.56406 11.7345 8.91715 11.0488 9.08575V9.08575Z"
        fill="#186EF9"
      />
      <path
        d="M9.21411 10.918C9.04563 11.6037 8.69259 12.2302 8.1933 12.7295C7.694 13.2288 7.06751 13.5819 6.38179 13.7504C6.55039 13.0647 6.90348 12.4383 7.40275 11.939C7.90203 11.4397 8.52845 11.0866 9.21411 10.918V10.918Z"
        fill="#0729F1"
      />
      <path
        d="M9.21411 9.08575C9.04563 8.40003 8.69259 7.77354 8.1933 7.27424C7.694 6.77495 7.06751 6.42191 6.38179 6.25343C6.55039 6.93909 6.90348 7.56551 7.40275 8.06479C7.90203 8.56406 8.52845 8.91715 9.21411 9.08575V9.08575Z"
        fill="#0046F8"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.130859)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default OKB;
